import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { push } from 'react-router-redux';

import { CLEAR_AUTHENTICATION_ERROR } from './constants';

import { PATH } from '../../constants/path';
import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../constants/cookie';
import { toRelativeUrl } from '../../utils/ssoUtil';

/**
 * Retourne true si la date d'expiration contenue dans le token est dépassé par la date du jour
 * si le format du token n'est pas bon alors jwtDecode lance une exception, on la catche et on retourne true
 * @param {*Token JWT} token
 * exp est un timestamp de la date d'expiration du token en secondes
 */
export function isTokenExpired(token) {
    // pas de token = pas de session : inutile de tenter un décodage (et de polluer la console)
    if (!token) {
        return true;
    }

    try {
        return moment().isAfter(moment.unix(jwtDecode(token).exp));
    } catch (e) {
        // token n'est pas au bon format, jwtDecode lance un exception
        // pour nous le token est donc expiré
        console.error(e);
        return true;
    }
}

/**
 * Redirige (via le routeur) vers l'URL renvoyée par le back dans les réponses du formulaire
 * Darty legacy (SsoDecodeTokenDto, décâblé côté front) :
 * - /connexion/darty?error=X ou /inscription/darty?error=X : anciennes URL du flux, que le
 *   routeur redirige vers /connexion?error=X (modale d'erreur)
 * - /rejoignez-le-programme?error=1 : membre non éligible
 * Utilisable directement comme errorCallback du middleware CALL_API.
 */
export function redirectToSsoUrl(response, dispatch) {
    const url = response && response.payload && response.payload.url;
    if (url) {
        dispatch(push(toRelativeUrl(url)));

        // l'erreur est portée par la modale (LoginErrorModalTrigger) : on efface
        // l'erreur globale du formulaire pour éviter un affichage redondant
        dispatch({ type: CLEAR_AUTHENTICATION_ERROR });
    }
}

/**
 * Destination après une connexion réussie (response = réponse de /auth/login, AuthDto) :
 * - membre limité : vue d'information dédiée /connexion?limited=1, prioritaire sur le
 *   chemin mémorisé (qui est alors abandonné) ;
 * - sinon : chemin mémorisé avant connexion (ex. posé par LoggedOutModal), ou fallbackPath.
 * La clé de session est consommée dans tous les cas.
 */
export function getPostLoginRedirectPath(response, fallbackPath) {
    const redirectAfterLogin = sessionStorage.getItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN);
    sessionStorage.removeItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN);

    if (response && response.payload && response.payload.limited) {
        return `${PATH.LOGIN_PATH}?limited=1`;
    }

    return redirectAfterLogin || fallbackPath;
}



// WEBPACK FOOTER //
// ./src/services/authentication/utils.js